<template>
  <div id="user-edit-tab-info">
    <div class="vx-col w-full">
      <div v-if="data_local.userdata.IdInfo == null">
        <table>
          <tr>
            <td class="font-semibold"> ID information is empty </td>
          </tr>
        </table>
      </div>
      <div v-else>
        <img :src="data_local.userdata.IdInfo.frontImage" style="width: 35%;min-width: 300px;" />
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";

export default {
  components: {
    vSelect,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: "",
      countrytext: "",
      phone: "",
      address: "",
      website: "",
      postcode: "",
      data_local: JSON.parse(JSON.stringify(this.userData)),

      departOptions: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
        { label: "10", value: "10" }
      ],
      roleOptions: [
        { label: "SuperAdmin", value: "superadmin" },
        { label: "president", value: "president" },
        { label: "Officer", value: "officer" },
        { label: "Researcher", value: "researcher" },
        { label: "Engineer", value: "engineer" },
      ],
      companyOptions: [
        { label: "7*9", value: "7*9" },
        { label: "3*9", value: "3*9" },
        { label: "5*4", value: "5*4" },
        { label: "8*2", value: "8*2" },
        { label: "AI", value: "ai" },
        { label: "Net", value: "net" },
      ],
      teamOptions: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
      ],
    };
  },
  computed: {
    status_local: {
      get() {
        const val = this.data_local.userdata.status === true ? "Approved" : "Pending";
        return { label: this.capitalize(val), value: val };
      },
      set(obj) {
        this.data_local.userdata.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.userdata.role),
          value: this.data_local.userdata.role,
        };
      },
      set(obj) {
        this.data_local.userdata.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes() {
      /* eslint-disable */
      //      if (!this.validateForm) return;

      const payload = {
        userDetails: {
          _id: this.data_local.userdata._id,
          firstname: this.data_local.userdata.firstname,
          lastname: this.data_local.userdata.lastname,
          userId: this.data_local.userdata.id,
          role: this.data_local.userdata.role,
          birthday: this.data_local.userdata.birthday,
          email: this.data_local.userdata.email,
          country: this.data_local.userdata.country
        },
        file: this.data_local.userdata.avatar,
      };
      // sending file to the backendthis.$store
      this.$store
        .dispatch("userManagement/updateUser", payload)
        .then((res) => {
          this.reset_data();
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "User Upload Failed!",
            text: res.message,
          });
          console.error(err);
        });

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    },
    update_avatar(e) {
      let files = e.target.files || e.dataTransfer.files;
      this.createImage(files[0]);
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      this.data_local.userdata.avatar = file;
      reader.onload = (e) => {
        document.getElementsByClassName("avatar_image")[0].src = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeAvatar() {
      this.data_local.userdata.avatar = ""
      document.getElementsByClassName(
        "avatar_image"
      )[0].src = require("@/assets/images/avatar.png");
    },
  },
  created() {

    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
  }
};
</script>
